import { Component, OnInit, ViewContainerRef } from '@angular/core';
import { Http, Response } from '@angular/http';
import { ToastsManager } from 'ng2-toastr/ng2-toastr';
import { ActivatedRoute, Router, RoutesRecognized } from '@angular/router';
import { PARTS } from '../models/part';
import { HeaderService } from '../header.service';
import { ProfileService } from '../profile.service';
import * as Globals from '../globals';
declare var $: any;

@Component({
  selector: 'app-agent',
  templateUrl: './agent.component.html',
  styleUrls: ['./agent.component.css']
})
export class AgentComponent implements OnInit {

  userProfile: any;
  authMenu: any;
  loading: boolean;
  search: string = '';
  parts: PARTS[];
  part: PARTS;
  p: number = 1;
  tab: number = 1;
  colSort: string[] = ['NAME'];
  reverse: boolean = false;
  col: number = 1;
  constructor(private http: Http, public toastr: ToastsManager, vRef: ViewContainerRef, private headerService: HeaderService, private profileService: ProfileService, private route: ActivatedRoute, private router: Router) {
    this.toastr.setRootViewContainerRef(vRef);
    this.authMenu = { M_FLAG: null };
    this.router.events.subscribe(event => {
      if (event instanceof RoutesRecognized) {
        if (event.url == '/auction/agent/0') {
          this.tab = 1;
          this.router.navigate(['/auction/agent/1']);
        }
      };
    });
  }
  ngOnInit() {
    let id = +this.route.snapshot.params['id'];
    if (id == 0) {
      this.router.navigate(['/auction/agent/1']);
    }
    this.parts = [];
    this.newPart();
    if (!this.profileService.userProfile) {
      this.profileService.signOut();
    } else {
      this.userProfile = this.profileService.userProfile;
      this.getParts();
      this.authMenu = Globals.getAuthMenu(102, this.userProfile);
    }

  }
  sort(val: number) {
    this.col = val;
    this.reverse = !this.reverse;
    switch (val) {
      case 1:
        this.colSort = ['NAME'];
        break;
      case 2:
        this.colSort = ['CONTACT_PERS'];
        break;
      case 3:
        this.colSort = ['TEL_NO'];
        break;
      case 4:
        this.colSort = ['FAX_NO'];
        break;
      default:
        break;
    }
  }
  newPart() {
    this.part = new PARTS(0, null, null, null, null, null, null, null, null, 16, '1', 17, '1');
  }
  getParts() {
    this.loading = true;
    this.http.get(Globals.serviceUrl + 'ref/parts?inst=1&search=' + this.search + '&t=' + new Date().getTime(), { headers: this.headerService.getHeader() })
      .subscribe((res) => {
        this.parts = res.json();
        this.loading = false;
      }, err => {
        console.log(err);
        this.toastr.error(Globals.errorMessage(err));
        this.loading = false;
      });
  }
  editPart(id: number) {
    this.http.get(Globals.serviceUrl + 'ref/parts?id=' + id + '&t=' + new Date().getTime(), { headers: this.headerService.getHeader() })
      .subscribe((res: Response) => {
        this.part = res.json();
        this.loading = false;
      }, err => {
        console.log(err);
        this.toastr.error(Globals.errorMessage(err));
        this.loading = false;
      });
  }
  savePart() {
    this.loading = true;
    if (this.part.PA_ID == 0) {
      this.http.post(Globals.serviceUrl + 'ref/parts', this.part, { headers: this.headerService.getHeader() })
        .subscribe((res: Response) => {
          this.toastr.success('Data berhasil disimpan');
          this.part = res.json();
          this.getParts();
          this.loading = false;
        }, err => {
          console.log(err);
          this.toastr.error(Globals.errorMessage(err));
          this.loading = false;
        });
    } else {
      this.http.put(Globals.serviceUrl + 'ref/parts?id=' + this.part.PA_ID, this.part, { headers: this.headerService.getHeader() })
        .subscribe((res: Response) => {
          this.toastr.success('Data berhasil disimpan');
          this.getParts();
          this.loading = false;
        }, err => {
          console.log(err);
          this.toastr.error(Globals.errorMessage(err));
          this.loading = false;
        });
    }
  }
  deletePart() {
    this.loading = true;
    this.http.delete(Globals.serviceUrl + 'ref/parts?id=' + this.part.PA_ID, { headers: this.headerService.getHeader() })
      .subscribe((res: Response) => {
        this.toastr.success('Data berhasil dihapus');
        this.getParts();
        this.tab = 1;
      }, err => {
        console.log(err);
        this.toastr.error(Globals.errorMessage(err));
        this.loading = false;
      });
  }

}



// WEBPACK FOOTER //
// C:/Users/oggy.yuristantyo/source/Workspaces/UI_SBN_Ritel_Web/src/app/agent/agent.component.ts